/**
 * Pure geometry helper for the agent-effect "scroll the touched row into view"
 * behavior. Separated from the React component so the decision is unit-testable
 * without a DOM/layout engine.
 */

/**
 * True when a row's vertical extent is ENTIRELY outside the viewport (fully
 * above or fully below). A partially-visible row returns false — we only yank
 * the list when the agent touched a row the user genuinely can't see (e.g.
 * editing a "Z" contact while scrolled to "A").
 */
export function isRowOffscreen(
  rect: { top: number; bottom: number },
  viewportHeight: number,
): boolean {
  return rect.bottom < 0 || rect.top > viewportHeight;
}
